export default __webpack_public_path__ + "static/media/Coins.ac22b8f5.png";